import React from "react";
import { Scope } from "informed";
import { TextInput, FileInput, DestinationPicker } from "../../shared/Forms";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";
import PropTypes from "prop-types";

const SpeakerInputs = props => {
	const { index } = props;

	return (
		<Scope scope={`speakers[${index}]`}>
			<TextInput field="name" id="name" placeholder="Speaker Name" isRequired />
			<FileInput field="imageUrl" id="imageUrl" placeholder="Image" />
			<DestinationPicker field="destination" id="destination" placeholder="destination" appKey={parseAppKey()} />
		</Scope>
	);
};

SpeakerInputs.propTypes = {
	index: PropTypes.number,
};

export default SpeakerInputs;
